import React, { Component } from "react";
import EditForm from "./form";
import DataDeletion from "./dataDeletion/dataDeletion";

export default class Settings extends Component {
  render() {
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <h2 style={{marginBottom: 10}}>Settings</h2>
          <EditForm />
          <DataDeletion />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/settings/settings.js